import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import type { RobotsFileToken } from '@sleed/bizcommerce-api';
import { robotsApi } from '~/lib/api/client';
import { formToToken, type RobotsFileFormValues } from '~/lib/schemas/robots-file';

export const robotsFileKeys = { all: ['robots-file'] as const };

/** Managed robots.txt, or the live storefront file as a prefill when nothing is managed yet (`isManaged: false`). */
export function useRobotsFile(enabled = true) {
	return useQuery<RobotsFileToken>({
		queryKey: robotsFileKeys.all,
		queryFn: async () => (await robotsApi.getContent()).data,
		enabled,
		refetchOnWindowFocus: false
	});
}

export function useSaveRobotsFile() {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: async (form: RobotsFileFormValues) => (await robotsApi.update(formToToken(form))).data,
		onSuccess: saved => qc.setQueryData(robotsFileKeys.all, saved)
	});
}
